<template>
  <!-- https://www.digitalocean.com/community/tutorials/how-to-build-a-text-to-speech-app-with-web-speech-api -->
  <q-btn
    :size="size || 'xs'"
    :rounded="label ? true : false"
    :round="label ? false : true"
    outline
    color="primary"
    @click.stop="onClickButton"
    v-touch-hold:500.mouse="showSettingsModal"
  >
    <div v-if="label" class="q-mr-sm">{{ label }}</div>

    <!-- <q-spinner-audio v-if="isSpeaking" color="primary" :size="size" /> -->

    <q-icon v-if="!hideIcon" :name="isSpeaking ? 'mdi-pause' : 'mdi-play'"/>

    <q-tooltip v-if="!hideTooltip"> Long-press for more options </q-tooltip>

    <slot />
  </q-btn>
</template>

<script>
import { useTextToSpeech, } from 'src/functions/function-tts'
export default {
  setup() {
    const { speak, pause, resume, isSpeaking } = useTextToSpeech()

    return {
      speak,
      pause,
      resume,
      isSpeaking,
    }
  },
  data() {
    return {
      textToSpeak: '',
      buttonWasClicked: false,
      isPaused: false,
    }
  },
  props: ['text', 'outline', 'label', 'size', 'pausable', 'hideTooltip', 'hideIcon'],
  mounted() {
    this.textToSpeak = this.text || 'some sample text'
    this.speak(' ') //just to initialize //TODO: check if still needed
  },
  computed: {
    ttsStatus() {
      return this.$stores.global.ttsStatus
    }
  },
  watch: {
    text(newValue) {
      this.textToSpeak = newValue
    },
    ttsStatus(newValue, oldValue) {
      if (newValue === 'VOICE_COMPLETE') {
        this.buttonWasClicked = false
      }
    },
  },
  methods: {
    showSettingsModal() {
      this.$stores.modals.userPrefsModal = { selectTab: 'tts' }
    },
    onClickButton(){
      if(this.isSpeaking){
        this.onClickPauseOrResume()
      }else {
        this.onClickSpeak()
      }
    },
    onClickSpeak() {
      this.buttonWasClicked = true
      this.speak(this.cleanText(this.textToSpeak))
    },
    onClickPauseOrResume() {
      if (this.isPaused) {
        this.resume();
      } else {
        this.pause();
      }
      this.isPaused = !this.isPaused;
    },
    //TODO: unify the "cleanText" methods later
    cleanText(text) {
      if (!text.length) return ''
      let cleanText = text.replaceAll('<div>', '. ')
      const regex = /(<([^>]+)>)/gi
      cleanText = cleanText.replace(regex, '').replace(/&nbsp;/g, ' ').trim()
      return cleanText
    },
  },
}
</script>
